import { render, staticRenderFns } from "./custom-flow-card.vue?vue&type=template&id=83cf20f2"
import script from "./custom-flow-card.vue?vue&type=script&lang=js"
export * from "./custom-flow-card.vue?vue&type=script&lang=js"
import style0 from "./custom-flow-card.vue?vue&type=style&index=0&id=83cf20f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports